import { setPollResponse, deletePoll, setCurrentChoice, resetPollResponseStatus } from 'features/polls/pollSlice'
import HorizontalLoader from 'loaders/HorizontalLoader'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components' 
import { toast } from 'react-toastify'
import { DotsButton4 } from 'components/dots/dots.styled'

import { LuVote } from "react-icons/lu";
import { FaRegCircle, FaRegCircleDot } from "react-icons/fa6"; 
import SpinnerSmall from 'components/SpinnerSmall'
import { setConfirmModalData, setViewConfirmModal } from 'features/modal/modalSlice'; 
import { Tooltip } from '@mui/material'
import { MdOutlineDeleteOutline, MdOutlinePoll } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function PollItem(props) {
  const { t: translate } = useTranslation()
    const dispatch = useDispatch()
    const { user, admin } = useSelector((state) => state.auth)
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { currentChoice, pollResponseStatus, pollResponseId, voteErrorMessage } = useSelector((state) => state.poll)
    const [ canViewResults, setCanViewResults ] = useState()  
    const [ hasUserResponded, setHasUserResponded ] = useState(false)
    const [ totalVotes, setTotalVotes ] = useState()
    const [ openResponse, setOpenResponse ] = useState('')
    const [ hasVoted, setHasVoted ] = useState(false)
    const [ isLoading, setIsLoading ] = useState(true)
    const [ isResponseLoading, setIsResponseLoading ] = useState(false)
    const navigate = useNavigate()
    const isThisPollSubmitting = pollResponseStatus === 'LOADING' && pollResponseId === props.data._id

    useEffect(() => {  
        // if the poll response type is "open", then we need to know if user has entered response or not.
        // if the poll response type is "predetermined", then we need to know if user has voted or not.
        // if the viewResults is "visible", then we need to know if user has voted or not.
        // if the viewResults is "user", then we need to know if user has voted or not.
        // if the viewResults is "hidden", then we need to know if user has voted or not. 
         

        if( props.data.responseType === 'open' ){

            let found = props.data.responses.find((ele) => ele.user.toString() === user._id)

            if(found){

                setHasUserResponded(true)
                setOpenResponse(found.response)
 
            }else{ 
                setHasUserResponded(false)
            }
        }else if( props.data.responseType === 'predetermined' ){ 
            
            if(user.isOrganization){
                setTotalVotes(props.data.participants.length)
                setCanViewResults(true)
            }else{

                let found = props.data.participants.find((ele) => ele.toString() === user._id) 

                if(found){
                    setHasVoted(true)
                }
                if(props.data.viewResults === 'visible'){
                    setCanViewResults(true)
                    setTotalVotes(props.data.participants.length)
                }else if(props.data.viewResults === 'user'){
                    if(found){
                        setCanViewResults(true)
                        setTotalVotes(props.data.participants.length) 
                    }
                }else if(props.data.viewResults === 'hidden'){
                    setCanViewResults(false)
                } 
            } 
        }
        setIsLoading(false) 
        setIsResponseLoading(false)

    },[ pollResponseStatus ])

    useEffect(() => {
         
        if(pollResponseId !== props.data._id) return

        if(pollResponseStatus === 'SUCCESS'){
            dispatch(resetPollResponseStatus())
        }else if(pollResponseStatus === 'ERROR'){
            setIsResponseLoading(false)
            toast.error(voteErrorMessage || translate('polls:errors.submit'))
            dispatch(resetPollResponseStatus())
        }
        
    },[dispatch, pollResponseId, pollResponseStatus, props.data._id, translate, voteErrorMessage])

    const handleSelectVote = (choice) => { 
        dispatch(setCurrentChoice({
            pollId: props.data._id,
            _id: choice._id,
            choice: choice.choice,
            arrayIndex: props.index, 
        })) 
    }

    const handleVote = () => { 
 
        if(!currentChoice?._id || currentChoice.pollId !== props.data._id){
            toast.error(translate('polls:validation.choice'))
            return;
        } 
        setIsResponseLoading(true)
        dispatch(setPollResponse({
            index: props.index,
            pollId: props.data._id,
            choice: currentChoice,
            choiceId: currentChoice._id
        })) 
    } 

    const handleOpenResponse = () => {
 
        if(!openResponse){
            toast.error(translate('polls:validation.response'))
            return;
        }

        setIsResponseLoading(true)

        dispatch(setPollResponse({
            index: props.index,
            pollId: props.data._id,
            response: openResponse,

        }))   
    }

    const handleDelete = () => { 
        dispatch(setConfirmModalData({ 
          text: 'Are you sure you want to delete this poll?',
          handler: () => dispatch(deletePoll({ churchId: profileChurch._id, pollId: props.data._id   })),
          confirmBtnBackgroundHover: '#642419',
        })) 
        dispatch(setViewConfirmModal(true))
    }

    const handleManagePoll = () => {
        navigate(`/polls/${props.data._id}`)
    }

    const renderVotingChoices = () => (
        <ChoicesContainer>
            {props.data?.choices?.map((choice) => (
                <ChoiceItem
                    key={choice._id}
                    selected={currentChoice?._id === choice._id && currentChoice?.pollId === props.data._id}
                    canVote={!hasVoted}
                    disabled={hasVoted}
                    onClick={() => handleSelectVote(choice)}
                >
                    {!hasVoted && (
                        currentChoice?._id === choice._id && currentChoice?.pollId === props.data._id
                            ? <FaRegCircleDot style={{color: '#21ad46'}} />
                            : <FaRegCircle style={{color: '#ccc'}} />
                    )}
                    <ChoiceVotedItem>{choice.choice}</ChoiceVotedItem>
                    {choice.votes?.some((id) => String(id) === String(user._id)) && (
                        <ProfilePic src={user.imagePath} />
                    )}
                </ChoiceItem>
            ))}
            {currentChoice?._id && currentChoice?.pollId === props.data._id && !hasVoted && (
                <SubmitBtnWrap>
                    <SubmitVoteBtn type='button' onClick={handleVote} disabled={isResponseLoading}>
                        {isResponseLoading ? <SpinnerSmall /> : translate('polls:actions.vote')}
                    </SubmitVoteBtn>
                </SubmitBtnWrap>
            )}
        </ChoicesContainer>
    )

    if(isLoading){
        return(
            <LoadingContainer>
                <HorizontalLoader />
            </LoadingContainer>
        )
    }
  
  return (
    <PollItemContainer> 
        {
            isLoading || isThisPollSubmitting ? (
                <LoadingContainer>  <HorizontalLoader /> </LoadingContainer>
            ) 
            :  
            (
                <>
 
                <PollCardHeader>
                    <PollCardMeta>
                        <PollTypeBadge>
                            <MdOutlinePoll />
                            {props.data.responseType === 'open' ? 'Open response' : 'Poll'}
                        </PollTypeBadge>
                        { (hasVoted || hasUserResponded) && (
                            <VotedBadge>
                                <LuVote />
                                Responded
                            </VotedBadge>
                        )} 
                    </PollCardMeta>

                    { (user.isOrganization || admin[profileChurch._id]) && (
                        <ButtonsWrap1>
                            <Tooltip title={translate('polls:detail.managerHint')} placement="top">
                                <CardActionButton onClick={handleManagePoll}  > <FiSettings size={19}/>  </CardActionButton>
                            </Tooltip>
                            <Tooltip title="Delete" placement="top">
                                <CardActionButton $danger onClick={handleDelete} >
                                    <MdOutlineDeleteOutline size={20}/>
                                </CardActionButton>                            
                            </Tooltip> 
                        </ButtonsWrap1>
                    )}
                </PollCardHeader>

                <PollItemQuestion>{props.data.title}</PollItemQuestion>
                    
                 
                { !isThisPollSubmitting && (canViewResults ||  user.isOrganization ) && props.data.responseType === 'predetermined' ?
                    (
                        <>
                        <ViewResultsContainer>
                            <TotalVotesText>  { props.data.responseType === 'predetermined' && ` ${translate("web:polls.totalVotes")} ${totalVotes}`  }   </TotalVotesText>

                            {
                                props.data && props.data.choices.map((choice) => (
                                    <ChoiceItemWrap key={choice._id}> 
                                        <ChoiceVotedItem  >{choice.choice} </ChoiceVotedItem> 
                                        <PercentTotal>
                                            <ChoiceVotedPercent 
                                            votesVal={choice.votes.length}  
                                            resWidth={`${choice.votes.length/totalVotes*100}%`}> 
                                                <span>{  totalVotes ? (choice.votes.length/totalVotes*100).toFixed(1) : 0 }%</span>
                                            </ChoiceVotedPercent>
        
                                            {choice.votes.find((id) => id === user._id) && (
                                                <ProfilePic  src={user.imagePath}  />
                                            )}
                                        </PercentTotal> 
                                    </ChoiceItemWrap> 
                                ))
                            }
                        </ViewResultsContainer>
                        {!hasVoted && !user.isOrganization && renderVotingChoices()}
                        </>
                    ) 
                    :  props.data.responseType === 'predetermined' ? 
                    renderVotingChoices() : props.data.responseType === 'open' && (
                        <ViewResultsContainer> 
                            
                            { hasUserResponded ? 
                                (
                                    <RespondedContainer> 
                                        <Responded>{translate('polls:detail.yourResponse')}</Responded>
                                        <UserResponseWrap>{openResponse}</UserResponseWrap>
                                    </RespondedContainer>
                                )
                                :
                                (
                                    <> 
                                        <PollResponseInput   
                                            style={{ color: 'var(--lightThemeFontColor)' }}
                                            placeholder={translate('polls:detail.responsePlaceholder')}
                                            disabled={isThisPollSubmitting}
                                            value={openResponse}
                                            onChange={(e) => setOpenResponse(e.target.value)}
                                            />  
                                            <SubmitBtnWrap>
                                                {
                                                    openResponse.length > 0 && (
                                                        <SubmitVoteBtn
                                                            onClick={handleOpenResponse}
                                                            > 
                                                            {isThisPollSubmitting && isResponseLoading ? (
                                                                    <SpinnerSmall />
                                                                ) :  (
                                                                    'Submit'
                                                                )
                                                            }
                                                        </SubmitVoteBtn>            
                                                    )                            
                                                } 
                                            </SubmitBtnWrap>   
                                    </>
                                )
                            } 
                        </ViewResultsContainer> 
                    ) 
                } 
            </>
        ) 
    } 
        </PollItemContainer>
    )
}

const ButtonsWrap1 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center; 
    justify-content: flex-end;
    font-size: 14px;
    color: var(--lightThemeFontColor);
    gap: 6px;
`

const TotalVotesText = styled.div`
    font-size: 13px; 
    color: #7b7f82;
    margin-bottom: 16px;
    font-weight: 500;
`

const UserResponseWrap = styled.div`
    background-color: #f7fafc;
    border: 1px solid #e7eef5;
    padding: 14px;
    width: 100%;
    border-radius: 8px;
    color: var(--lightThemeFontColor);
    line-height: 1.5;
`

const RespondedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    justify-content: flex-start;    
    margin-top: 20px;
    justify-content: flex-end;
`

const Responded = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
    justify-content: flex-end;
    font-size: 13px;
    color: #7b7f82;
    font-weight: 600;
`


const PollResponseInput = styled.textarea` 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end; 
    border: 1px solid #dfe7ec;
    outline: none;
    border-radius: 8px;
    padding: 14px;
    resize: none;
    font-family: 'Roboto', sans-serif;
    min-height: 112px;
    width: 100%;
    transition: 0.3s;
    font-size: 14px;
    color: var(--lightThemeFontColor);
    background: #fbfcfd;

    &:focus{
        border-color: #21ad46;
        box-shadow: 0 0 0 3px rgba(33, 173, 70, 0.12);
    }
`

const SubmitBtnWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;
    justify-content: flex-end;
`

const SubmitVoteBtn = styled.button`
    padding: 10px;
    border: none;
    width: 110px;
    height: 40px;
    background-color: #21ad46;
    color: white;
    cursor: pointer;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    font-weight: 600;
    box-shadow: 0 8px 18px rgba(33, 173, 70, 0.18);


    &:hover{
        background-color: #1e9d41;
        transform: translateY(-1px);
    }

`

const ProfilePic = styled.img`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
    border: 2px solid #21ad46;
`

const PollItemContainer = styled.div`
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    border-radius: 8px;
    padding: 18px;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.12);
    border: 1px solid #edf0f2;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 100%;
    min-width: 400px;
    position: relative;
    color: var(--dFontColor);
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;

    &:hover {
        box-shadow: 0 10px 24px rgba(61, 70, 78, 0.16);
        border-color: #e0e7eb;
        transform: translateY(-1px);
    }

    @media (max-width: 768px) {
        margin-bottom: 10px;
        min-width: unset;
        width: 100%;
        margin-right: 0;
        padding: 16px;
    }
` 

const PollCardHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
`

const PollCardMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
`

const PollTypeBadge = styled.div`
    height: 28px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0 10px;
    border-radius: 6px;
    background: #f2f6f8;
    color: #626b70;
    font-size: 12px;
    font-weight: 600;

    svg {
        font-size: 16px;
        color: var(--themeColor);
    }
`

const VotedBadge = styled(PollTypeBadge)`
    background: #eef9f1;
    color: #168236;

    svg {
        color: #21ad46;
    }
`

const CardActionButton = styled(DotsButton4)`
    background: #f7f8fa;
    color: ${props => props.$danger ? '#9c3a31' : 'var(--lightThemeFontColor)'};
    width: 34px;
    height: 34px;
    border-radius: 7px;

    &:hover {
        background: ${props => props.$danger ? '#f7ebe9' : '#eef1f3'};
        color: ${props => props.$danger ? '#9c3a31' : 'var(--lightThemeFontColor)'};
    }
`

const PollItemQuestion = styled.div`
    margin-bottom: 22px;
    font-size: 19px;
    line-height: 1.35;
    font-weight: 600;
    width: 100%;
    text-align: left;
    color: var(--lightThemeFontColor);
`

const ChoicesContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
`
const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
`

const ChoiceItem = styled.button`
    padding: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background-color: ${props => props.selected ? '#f4fff7' : '#fbfcfd'};
    width: 100%; 
    cursor: pointer;
    margin-bottom: 10px;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    border: 1px solid ${props => props.selected ? '#21ad46' : '#dfe7ec'};
    transition: 0.25s;
    border-radius: 8px;
    position: relative;

    svg{
        margin-right: 10px;
        flex-shrink: 0;
    }

    &:hover{
        border-color: ${props => props.canVote ? '#21ad46' : '#cfd8de'};
        background: ${props => props.canVote ? '#f7fff9' : '#fbfcfd'};
    }
`

const ChoiceItemWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 18px;

    &:last-child {
        margin-bottom: 0;
    }
    
`


const PercentTotal = styled.div`
    width: 100%;
    background-color: #f2f5f7;
    border: 1px solid #dfe7ec;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    overflow: hidden;
    min-height: 44px;
`

const ChoiceVotedPercent = styled.div`
    width: ${props => props.resWidth };
    min-width: ${props => props.votesVal ? '52px' : '0px'};
    background-color: ${props => props.votesVal ? ('rgba(41, 123, 216, 0.28);'):('transparent')};
    padding: ${props => props.votesVal ? '0 12px' : '0'};
    height: 44px;
    color: #4f5960;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 13px;
    font-weight: 700;
    transition: width 0.3s ease;

    span {
        position: relative;
        z-index: 1;
        white-space: nowrap;
    }

`

const ChoiceVotedItem = styled.div`
    margin-bottom: 4px;
    font-size: 15px;
    color: var(--lightThemeFontColor);
    line-height: 1.4;
`


const ViewResultsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--dFontColor);
`
